<script>
export default {
  name: 'TableFooter',
  props: {
    curPage: { type: Number, required: true },
    totalNum: { type: Number, required: true },
    perPage: { type: Number, required: false, default: 10 },
    hidePerPage: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      perPageData: [10, 25, 50, 100],
    }
  },
  computed: {
    pageTotal() {
      return Math.ceil(this.totalNum / this.perPage)
    },
    pageArr() {
      if (this.pageTotal === 1) {
        return []
      } else if (this.pageTotal <= 5) {
        return this.pageTotal
      } else if (this.curPage < 5) {
        return [1, 2, 3, 4, 5, '...', this.pageTotal]
      } else if (this.pageTotal - this.curPage < 4) {
        return [
          1,
          '...',
          this.pageTotal - 4,
          this.pageTotal - 3,
          this.pageTotal - 2,
          this.pageTotal - 1,
          this.pageTotal,
        ]
      } else {
        return [
          1,
          '...',
          this.curPage - 1,
          this.curPage,
          this.curPage + 1,
          '...',
          this.pageTotal,
        ]
      }
    },
  },
  methods: {
    setPage(params) {
      if (params.page === '...') {
        return
      }
      if (params.page === this.curPage && params.perPage === this.perPage) {
        return
      }
      this.$emit('set-page', params)
    },
  },
}
</script>

<template>
  <div class="flex justify-between pl-8 pt-6">
    <div class="flex">
      <span
        v-for="(page, index) in pageArr"
        :key="index"
        :class="[
          $style.item,
          'text-blue',
          page === '...'
            ? 'cursor-default'
            : 'cursor-pointer hover:bg-blue hover:text-white',
          page === curPage && 'cursor-default bg-blue text-white',
        ]"
        @click="() => setPage({ page, perPage })"
      >
        {{ page }}
      </span>
    </div>
    <div v-if="totalNum > 10 && !hidePerPage" class="flex">
      <div class="mr-5 text-gray-light">View:</div>
      <span
        v-for="num in perPageData"
        :key="num"
        :class="[
          $style.item,
          'cursor-pointer text-gray-light hover:bg-gray hover:text-white',
          num === perPage && 'cursor-default bg-gray text-white',
        ]"
        @click="() => setPage({ page: 1, perPage: num })"
      >
        {{ num }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" module>
.item {
  @apply px-2.5 h-7.5 leading-relax text-center mr-1 rounded-md;
}
</style>
